import { useState } from 'react';
import { LoadingOutlined, RightOutlined, LockOutlined } from '@ant-design/icons';

interface Props {
  label: string;
  accent: string;
  accentDark: string;
  loading: boolean;
  /** BE'dan keladi: tugma faolmi yoki yo'q */
  enabled?: boolean;
  /** Disabled holatda foydalanuvchiga ko'rsatish uchun sabab */
  disabledReason?: string | null;
  onClick: () => void;
}

/**
 * Plan-rangida gradient CTA tugma. Provider panel button uslubida —
 * gradient + shadow + inset highlight + press scale animatsiya.
 */
export default function CheckoutButton({
  label,
  accent,
  accentDark,
  loading,
  enabled = true,
  disabledReason,
  onClick,
}: Props) {
  const [pressed, setPressed] = useState(false);
  const isDisabled = !enabled || loading;

  return (
    <div>
      <button
        type="button"
        onClick={() => !isDisabled && onClick()}
        disabled={isDisabled}
        onTouchStart={() => !isDisabled && setPressed(true)}
        onTouchEnd={() => setPressed(false)}
        onTouchCancel={() => setPressed(false)}
        onMouseDown={() => !isDisabled && setPressed(true)}
        onMouseUp={() => setPressed(false)}
        onMouseLeave={() => setPressed(false)}
        style={{
          width: '100%',
          minHeight: 48,
          padding: '0 18px',
          border: enabled
            ? `1px solid ${accent}29`
            : '1px solid var(--bl-divider, #ebebeb)',
          borderRadius: 14,
          background: enabled
            ? `linear-gradient(135deg, ${accent} 0%, ${accentDark} 100%)`
            : 'var(--bl-surface-soft, #f0f4f8)',
          color: enabled ? '#fff' : 'var(--bl-text-muted, #9ca3af)',
          fontSize: 15,
          fontWeight: 700,
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.85 : 1,
          boxShadow: enabled
            ? `0 6px 18px ${accent}3a, inset 0 1px 0 rgba(255,255,255,0.20)`
            : 'none',
          transform: pressed && !isDisabled ? 'scale(0.985)' : 'scale(1)',
          transition: 'transform 0.12s ease, opacity 0.15s ease',
          WebkitTapHighlightColor: 'transparent',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          outline: 'none',
          letterSpacing: 0.15,
          fontFamily: 'inherit',
        }}
      >
        {!enabled ? (
          <LockOutlined style={{ fontSize: 13 }} />
        ) : loading ? (
          <LoadingOutlined spin style={{ fontSize: 15 }} />
        ) : (
          <RightOutlined style={{ fontSize: 12 }} />
        )}
        <span>{label}</span>
      </button>

      {!enabled && disabledReason && (
        <div
          style={{
            marginTop: 6,
            padding: '0 4px',
            fontSize: 11,
            color: 'var(--bl-text-muted, #9ca3af)',
            lineHeight: 1.4,
            textAlign: 'center',
          }}
        >
          {disabledReason}
        </div>
      )}
    </div>
  );
}
